import { createSlice } from "@reduxjs/toolkit";
import { getClientDetails } from "./thunk";

const getClientDetailSlice = createSlice({
    name: "getClientDetails",
    initialState: {
        isLoading: false,
        isError: false,
        clientDetails: {},
    },
    extraReducers: (builder) => {
        builder.addCase(getClientDetails.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getClientDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clientDetails = action.payload.clientDetails;
        });
        builder.addCase(getClientDetails.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default getClientDetailSlice.reducer;